import { Button } from "./Button";
import { Text } from "./Text";
import { Heading } from "./Heading";
import { Form } from "./Form";
import { Link } from "./Link";

export const components = {
  Button,
  Heading,
  Text,
  Form,
  Link
};
